export default __webpack_public_path__ + "static/media/carosello10.937e02ce.png";